export function pickFields<T extends Record<string, unknown>>(
  data: T[],
  keep: string[],
) {
  return data.map((item) => {
    return keep.reduce<Partial<T>>((acc, key) => {
      if (key in item) {
        acc[key as keyof T] = item[key as keyof T];
      }
      return acc;
    }, {} as T);
  });
}
